import { Link } from 'react-router-dom';
import { en } from '@/i18n/en';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div>
          <h4>{en.brand.name}</h4>
          <p className="tag-line">{en.brand.tagline}</p>
        </div>
        <div>
          <h5 className="col-title">Produit</h5>
          <ul>
            <li><a href="#how">Comment ça marche</a></li>
            <li><a href="#formats">Formats supportés</a></li>
            <li><a href="#pricing">Tarifs</a></li>
            <li><a href="#faq">FAQ</a></li>
          </ul>
        </div>
        <div>
          <h5 className="col-title">Ressources</h5>
          <ul>
            <li><a href="https://github.com/myinvoice/myinvoice">GitHub</a></li>
            <li><a href="/docs/api.md">Documentation API</a></li>
            <li><a href="/docs/security.md">Sécurité & Chiffrement</a></li>
          </ul>
        </div>
        <div>
          <h5 className="col-title">Légal</h5>
          <ul>
            <li><Link to="/terms">Conditions Générales</Link></li>
            <li><Link to="/privacy">Politique de Confidentialité</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="col-title">Contact</h5>
          <ul>
            <li><a href="mailto:contact@myinvoice.local">contact@myinvoice.local</a></li>
            <li><a href="mailto:support@myinvoice.local">support@myinvoice.local</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {en.brand.name}. Facturation intelligente et sécurisée.</span>
        <div className="socials">
          <a href="#" aria-label="GitHub">GH</a>
          <a href="#" aria-label="LinkedIn">in</a>
        </div>
      </div>
    </footer>
  );
}
